import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BBInvitations, BBSelfGuidedInvite } from '../components/invitations/bb-invitations/bb-invitation';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { BBInvitationList, BBInvitationQuery } from '../components/invitations/bb-invitations/bb-invitation-list';

@Injectable({
  providedIn: 'root'
})
export class BbInvitationService {

  apiUrl = environment.apiUrl

  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,private _authservice:AuthService) { }

  getQueryParams(filter: BBInvitationQuery): HttpParams {
      return new HttpParams({ fromObject: filter })
    }

  createbbinvitation(bbinvitation:BBInvitations):Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    const { id, ...payload } = bbinvitation;
    return this.http.post(this.apiUrl + 'bbinvitation/bbcoached/createInvite', payload, { headers:headers});
  }

  getAllBBInvitations(queryFilter:BBInvitationQuery):Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let params = this.getQueryParams(queryFilter);
    return this.http.get<BBInvitationList[]>(this.apiUrl+'bbinvitation/bbcoached/getAllInvitations',{headers:headers,params:params,observe:'response'})
  }

  getBBInvitationDetailsForView(id:string):Observable<any>
  {
     const token = this._authservice.getAuthToken();
     const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
     let params = new HttpParams();
     params = params.append('id',id.toString());
     return this.http.get(this.apiUrl+'bbinvitation/bbcoached/getBBInvitationDetailsForView',{headers:headers,params:params})
  }

  getBBInvitationDetailsForUpdate(id:string):Observable<any>
  {
     const token = this._authservice.getAuthToken();
     const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
     let params = new HttpParams();
     params = params.append('id',id.toString());
     return this.http.get(this.apiUrl+'bbinvitation/bbcoached/getBBInvitationDetailsForUpdate',{headers:headers,params:params})
  }

  updatebbinvitation(bbinvitation:BBInvitations):Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.post(this.apiUrl + 'bbinvitation/bbcoached/updateInvite', bbinvitation, { headers:headers});
  }


  resendBBInvitation(id:string,newExpiryDate:string):Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.post(this.apiUrl + 'bbinvitation/bbcoached/resendInvite', {id:id,newExpiryDate:newExpiryDate}, { headers:headers});
  }

  getBBInvitationAuditLogs(id:string):Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let params = new HttpParams();
    params = params.append('id',id.toString());
    return this.http.get(this.apiUrl+'bbinvitation/bbcoached/getBBInvitationAuditLogs',{headers:headers,params:params})
  }

  accessBBInviteLink(guid:string):Observable<any>
  {
    let params = new HttpParams();
    params = params.append('guid',guid.toString());
    return this.http.post(this.apiUrl+'bbinvitation/bbcoached/accessInvitation',null,{params:params})
  }

  getEmailFromInvitationGuid(guid:string):Observable<any>
  {
    let params = new HttpParams();
    params = params.append('guid',guid.toString());
    return this.http.get(this.apiUrl+'bbinvitation/bbcoached/getEmailFromBBInvitationGuid',{params:params})
  }
  
  createbbselfguidedinvitation(bbsgpinvitation:BBSelfGuidedInvite):Observable<any>
  {  
    return this.http.post(this.apiUrl + 'bbinvitation/bbselfguided/createSelfGuidedInvite', bbsgpinvitation);
  }

  accessBBSelfGuidedInviteLink(guid:string):Observable<any>
  {
    let params = new HttpParams();
    params = params.append('guid',guid.toString());
    return this.http.post(this.apiUrl+'bbinvitation/bbselfguided/accessBBSelfGuidedInvitation',null,{params:params})
  }

  getEmailFromBBSelfGuidedInvitationGuid(guid:string):Observable<any>
  {
    let params = new HttpParams();
    params = params.append('guid',guid.toString());
    return this.http.get(this.apiUrl+'bbinvitation/bbselfguided/getEmailFromBBSelfGuidedInvitationGuid',{params:params})
  }

  getPrefilledDataForCoach():Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.get(this.apiUrl+'bbinvitation/bbcoached/getPrefilledDataForCoach',{headers:headers})
  }
}
